import { Link } from "react-router-dom";

export const Logo = ({ light = true, className = "", testId = "nav-logo" }) => (
  <Link
    to="/"
    data-testid={testId}
    aria-label="terraloop.cl inicio"
    className={`logo-wrap inline-flex items-end font-display font-extrabold tracking-tight text-[1.45rem] leading-none select-none ${className}`}
  >
    <span className={light ? "text-[#f4f7f6]" : "text-[#05130e]"}>
      TERRA
    </span>
    <span className="text-[#00f2a1] ml-[0.08em]">
      LO
      <span className="relative inline-block">
        O
        <span className="absolute left-1/2 top-[52%] -translate-x-1/2 -translate-y-1/2 w-[0.5em] h-[0.5em] pointer-events-none" aria-hidden="true">
          <span className="logo-orbit block w-full h-full">
            <span className={`absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 w-[0.2em] h-[0.2em] rounded-full shadow-[0_0_8px_#00f2a1] ${light ? "bg-white" : "bg-[#05130e]"}`} />
          </span>
        </span>
      </span>
      P
    </span>
    <span className={`font-mono text-[0.55rem] ml-1 mb-[0.1em] ${light ? "text-slate-400" : "text-slate-500"}`}>.cl</span>
  </Link>
);
